import { render, staticRenderFns } from "./wordLookupModalV2.vue?vue&type=template&id=3fd2d944&scoped=true&"
import script from "./wordLookupModalV2.vue?vue&type=script&lang=js&"
export * from "./wordLookupModalV2.vue?vue&type=script&lang=js&"
import style0 from "./wordLookupModalV2.vue?vue&type=style&index=0&id=3fd2d944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2d944",
  null
  
)

export default component.exports